import standardDetailLayoutRoute from '@input-web/modules/standard/views/detail-layout/standard-detail-layout.route';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

const standardAdditionalDetailRoute = createRoute({
  component: lazyRouteComponent(() => import('./standard-additional-detail.view')),
  getParentRoute: () => standardDetailLayoutRoute,
  path: '/additional',
});

export default standardAdditionalDetailRoute;
